<ul class="images" *ngIf="images && images.length > 0" id="container-imageResultsComponent">
    <li *ngFor="let image of images">
        <a (click)="pushImageRowClickToGA(image)" [routerLink]="[docUrl + image.docId]"  [queryParams]="{'searchId': image.searchId}">
            <img [attr.src]="image.url" [attr.alt]="image.caption" [attr.title]="image.caption | pqCleanText: true">
        </a>
    </li>
    <li class="container-viewAllImages">
        <a (click)="pushImageRowViewAllClickToGA()" [routerLink]="[resultsUrl]" [queryParams]="{ 'query': query, 'source': 'Images' }">View all<br>images</a>
    </li>
</ul>
